(function () {
	function init() {
		const _controls = document.querySelectorAll('.js-tab-controls');
		
		for (let i = 0, length = _controls.length; i < length; i++) {
			_controls[i].addEventListener('click', click);
		}
		
		const _selects = document.querySelectorAll('.js-tab-select');
		
		for (let i = 0, length = _selects.length; i < length; i++) {
			_selects[i].addEventListener('change', change);
		}
	}
	
	function change(event) {
		util.addClass(document.getElementById(event.target[event.target.selectedIndex].value), 'is-visible');
		util.removeClass(util.closestParent(event.target, '.js-tab-panel'), 'is-visible');
		
		for (let i = 0, length = event.target.options.length; i < length; i++) {
			if (event.target.options[i].defaultSelected) {
				event.target.selectedIndex = i;
			}
		}
	}
	
	function click(event) {
		if (!event.target.hasAttribute('href')) {
			return;
		}
		
		event.preventDefault();
		
		util.addClass(document.querySelector(event.target.getAttribute('href')), 'is-visible');
		util.removeClass(util.closestParent(event.target, '.js-tab-panel'), 'is-visible');
	}
	
	init();
}());